module.exports = __webpack_public_path__ + "img/galeria-esp-marinas-1.6016414b.jpg";